import React from 'react';
import { AlertTriangle } from 'lucide-react';

export default function ConfirmModal({ open, title, message, onConfirm, onCancel, danger }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onCancel} />
      <div className="relative w-full max-w-sm bg-surface-800 border border-white/10 rounded-xl p-6">
        <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-4 ${danger ? 'bg-red-500/10' : 'bg-primary-500/10'}`}>
          <AlertTriangle size={22} className={danger ? 'text-red-400' : 'text-primary-400'} />
        </div>
        <h3 className="font-semibold text-white mb-2">{title}</h3>
        <p className="text-white/50 text-sm leading-relaxed mb-6">{message}</p>
        <div className="flex gap-2">
          <button
            onClick={onConfirm}
            className={`flex-1 justify-center ${danger ? 'bg-red-500 hover:bg-red-600 text-white font-medium px-4 py-2 rounded-lg text-sm transition-colors active:scale-95' : 'btn-primary'}`}
          >
            Confirm
          </button>
          <button onClick={onCancel} className="btn-secondary flex-1 justify-center">Cancel</button>
        </div>
      </div>
    </div>
  );
}